import { render, staticRenderFns } from "./FAQOfferDealsComponent.vue?vue&type=template&id=5803af4c&scoped=true&"
import script from "./FAQOfferDealsComponent.vue?vue&type=script&lang=ts&"
export * from "./FAQOfferDealsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FAQOfferDealsComponent.vue?vue&type=style&index=0&id=5803af4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5803af4c",
  null
  
)

export default component.exports